import DownloadAppModal from './DownloadAppModal'

export default DownloadAppModal
// eslint-disable-next-line import/export
export * from './DownloadAppModal'
